import * as React from "react";
export const OpenExternalIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <path d="M20.4 13.2v7.2a3.6 3.6 0 01-3.6 3.6H3.6A3.6 3.6 0 010 20.4V7.2a3.6 3.6 0 013.6-3.6h7.2a1.2 1.2 0 010 2.4H3.6a1.2 1.2 0 00-1.2 1.2v13.2a1.2 1.2 0 001.2 1.2h13.2a1.2 1.2 0 001.2-1.2v-7.2a1.2 1.2 0 012.4 0zM23.91.74A1.2 1.2 0 0022.8 0h-7.2a1.2 1.2 0 100 2.4h4.3L8.75 13.55a1.2 1.2 0 000 1.7 1.21 1.21 0 001.7 0L21.6 4.1v4.3a1.2 1.2 0 102.4 0V1.2a1.22 1.22 0 00-.09-.46z" />
  </svg>
);
